export function mediaTextAlign() {
	document.querySelectorAll('.wp-block-media-text.alignfull.alignwide').forEach(el => {
		el.classList.remove('alignwide');
	});
}

document.addEventListener('DOMContentLoaded', () => mediaTextAlign());
